module.exports = __webpack_public_path__ + "static/media/feature_icon_2.c3ca28f0.png";